var exports = {
  "Zd": "x805b157e--f77a4d--form",
  "zQ": "x805b157e--f77a4d--search-page",
};

module.exports = exports;
